import { render, staticRenderFns } from "./RcclNewsIndex.vue?vue&type=template&id=d2552228&scoped=true"
import script from "./RcclNewsIndex.vue?vue&type=script&lang=js"
export * from "./RcclNewsIndex.vue?vue&type=script&lang=js"
import style0 from "./RcclNewsIndex.vue?vue&type=style&index=0&id=d2552228&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2552228",
  null
  
)

export default component.exports